import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import './AdminExam.css';
import API_BASE_URL from '../../config';

const AdminExam = () => {
    // 1. Khởi tạo State với trường year mặc định là năm hiện tại
    const [examData, setExamData] = useState({
        test_id: '',
        exam_type: 'reading',
        title: '',
        content: '',
        year: new Date().getFullYear().toString(),
        audio_file: null,
        image_file: null
    });

    const [isExistingExam, setIsExistingExam] = useState(false);

    // Danh sách năm cho phần chọn Year
    const years = Array.from({ length: 11 }, (_, i) => (new Date().getFullYear() - i).toString());

    useEffect(() => {
        localStorage.setItem('draft_exam', JSON.stringify(examData));
    }, [examData]);

    useEffect(() => {
        const saved = localStorage.getItem('draft_exam');
        if (saved) {
            try {
                setExamData(JSON.parse(saved));
            } catch (e) {
                console.error("Error parsing draft:", e);
            }
        }
    }, []);

    // 2. Logic Kiểm tra mã đề (Check ID)
    const loadExistingExam = async () => {
        if (!examData.test_id) return alert("Please enter a Test ID first!");
        
        try {
            const res = await axios.get(`${API_BASE_URL}/api/exams/detail/${examData.test_id.trim()}`);
            if (res.data) {
                setExamData({
                    ...examData,
                    title: res.data.title || res.data.test_name || '',
                    content: res.data.content || '',
                    year: res.data.year || new Date().getFullYear().toString(),
                    exam_type: res.data.exam_type || 'reading'
                });
                setIsExistingExam(true);
                alert("Existing exam data loaded successfully!");
            }
        } catch (error) {
            if (error.response?.status === 404) {
                alert("Test ID not found. You can create this as a new exam.");
                setIsExistingExam(false);
            } else {
                alert("Connection error.");
            }
        }
    };

    // 3. Logic Gửi dữ liệu (FIX: Đã thêm formData.append cho 'year')
    const handleSubmit = async (e) => {
    e.preventDefault();

    const token = localStorage.getItem("token"); // ✅ KHAI BÁO Ở ĐÂY
    console.log("TOKEN:", token); // 🔥 debug

    if (!token) {
        alert("Bạn chưa đăng nhập!");
        return;
    }

    try {
        const formData = new FormData();
        const cleanTestId = examData.test_id.trim();
        
        formData.append('test_id', cleanTestId);
        formData.append('test_name', ""); 
        formData.append('exam_type', examData.exam_type);
        formData.append('title', examData.title);
        formData.append('year', examData.year);
        formData.append('content', examData.content || "");

        if (examData.audio_file) formData.append('audio', examData.audio_file);
        if (examData.image_file) formData.append('image', examData.image_file);

        await axios.post(
            `${API_BASE_URL}/api/exams/add`,
            formData,
            {
                headers: {
                    //'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${token}` // ✅ dùng token đã khai báo
                }
            }
        );

        alert("Exam published successfully! ✨");

        // reset form (giữ nguyên)
        setExamData({
            test_id: '',
            exam_type: 'reading',
            title: '',
            content: '',
            year: new Date().getFullYear().toString(),
            audio_file: null,
            image_file: null
        });

    } catch (error) {
        alert("Save failed: " + (error.response?.data?.error || error.message));
    }
};

    return (
        <div className="admin-page-container">
            <div className="admin-content-wrapper">
                <div className="page-header-section">
                    <h2 className="page-title">Exam Content Creator ✍️</h2>
                    <p className="page-subtitle">Draft and publish your IELTS exam materials</p>
                    {isExistingExam ? (
                        <span className="status-badge editing">🟢 EDITING MODE</span>
                    ) : (
                        <span className="status-badge new">🟡 NEW ENTRY</span>
                    )}
                </div>

                <form onSubmit={handleSubmit} className="admin-card-form">
                    <div className="form-section-grid">
                        {/* ID & Check Button */}
                        <div className="form-group">
                            <label>Unique Test ID</label>
                            <div className="input-with-action">
                                <input 
                                    type="text" 
                                    placeholder="e.g., test1_reading_2026"
                                    value={examData.test_id}
                                    onChange={(e) => setExamData({...examData, test_id: e.target.value})}
                                    required
                                />
                                <button type="button" onClick={loadExistingExam} className="btn-check">Check</button>
                            </div>
                        </div>

                        {/* Skill & Year Selection */}
                        <div className="form-row">
                            <div className="form-group">
                                <label>Exam Skill</label>
                                <select 
                                    value={examData.exam_type} 
                                    onChange={(e) => setExamData({...examData, exam_type: e.target.value})}
                                >
                                    <option value="reading">Reading</option>
                                    <option value="listening">Listening</option>
                                    <option value="writing">Writing</option>
                                </select>
                            </div>
                            <div className="form-group">
                                <label>Target Year</label>
                                <select 
                                    value={examData.year} 
                                    onChange={(e) => setExamData({...examData, year: e.target.value})}
                                >
                                    {years.map(y => <option key={y} value={y}>{y}</option>)}
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Exam Title */}
                    <div className="form-group full-width">
                        <label>Exam Title</label>
                        <input 
                            type="text" 
                            className="title-input"
                            placeholder="Enter the official title..."
                            value={examData.title}
                            onChange={(e) => setExamData({...examData, title: e.target.value})}
                            required
                        />
                    </div>

                    {/* Media Uploads */}
                    <div className="media-upload-area">
                        {/* IMAGE */}
                        <div className="form-group">
                            <label>Task Image (Optional)</label>
                            <input 
                                id="imageInput"
                                type="file" 
                                accept="image/*"
                                onChange={(e) => setExamData({...examData, image_file: e.target.files[0]})}
                            />
                        </div>

                        {/* AUDIO */}
                        <div className="form-group">
                            <label>Audio Track (Optional)</label>
                            <input 
                                id="audioInput"
                                type="file" 
                                accept="audio/*"
                                onChange={(e) => setExamData({...examData, audio_file: e.target.files[0]})}
                            />
                        </div>
                    </div>

                    {/* Content Editor */}
                    <div className="form-group full-width">
                        <label>Exam Content</label>
                        <div className="editor-container">
                            <CKEditor
                                key={examData.test_id}
                                editor={ClassicEditor}
                                data={examData.content}
                                onChange={(event, editor) => {
                                    const data = editor.getData();
                                    setExamData(prev => ({ ...prev, content: data }));
                                }}
                            />
                        </div>
                    </div>

                    <div className="form-actions">
                        <button type="button" className="btn-clear" onClick={() => {
                            setExamData({ ...examData, title: '', content: '', test_id: '' });
                            setIsExistingExam(false);
                        }}>
                            Clear Draft
                        </button>
                        <button type="submit" className="btn-submit-save">
                            PUBLISH EXAM ✨
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AdminExam;